// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-SongRequestsPublic-module__emptyState-w0IaB {
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/SongRequestsPublic.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;EACnB,4BAA4B;AAC9B","sourcesContent":[".emptyState {\n  display: grid;\n  place-items: center;\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": `nightbot-SongRequestsPublic-module__emptyState-w0IaB`
};
export default ___CSS_LOADER_EXPORT___;
